import styled from 'styled-components';

export const Container = styled.div`
  background-color: #FFF;
  display: flex;
  justify-content: center;

  #print {
    max-width: 1366px;
  }
`;
